import script from "./TPainelDeEstatisticas.vue?vue&type=script&setup=true&lang=ts"
export * from "./TPainelDeEstatisticas.vue?vue&type=script&setup=true&lang=ts"

import "./TPainelDeEstatisticas.vue?vue&type=style&index=0&id=0ef02ae5&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ef02ae5"]])

export default __exports__